import React, { useCallback, useEffect, useState } from 'react';
import { Navigate, useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AdminSubpage from '../components/AdminSubpage';
import ProductEdit from '../components/ProductEdit';
import { productsAPI } from '../services/api';
import { isInfluencerUser } from '../utils/auth';

const ProductEditPage = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const state = location.state || {};
  const backTo = state.backTo || '/products';
  const influencerId = state.influencerId;
  const isClosetProduct = Boolean(state.isClosetProduct);

  const isEdit = Boolean(productId);
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(isEdit);

  const load = useCallback(async () => {
    if (!productId) return;
    setLoading(true);
    try {
      const response = await productsAPI.getById(productId);
      setProduct(response.data);
    } catch (error) {
      toast.error(
        'Error loading product: ' + (error.response?.data?.message || error.message)
      );
      setProduct(null);
    } finally {
      setLoading(false);
    }
  }, [productId]);

  useEffect(() => {
    if (isEdit) void load();
    else setProduct(null);
  }, [isEdit, load]);

  const handleClose = () => navigate(backTo);

  const handleUpdate = () => navigate(backTo);

  const title =
    isEdit ? 'Edit product' : isClosetProduct ? 'New closet product' : 'New product';

  if (isInfluencerUser()) {
    return <Navigate to="/products" replace />;
  }

  return (
    <AdminSubpage title={title} backTo={backTo}>
      {loading ? (
        <div className="loading">Loading…</div>
      ) : isEdit && !product ? (
        <p>Could not load product.</p>
      ) : (
        <ProductEdit
          product={product}
          influencerId={influencerId}
          isClosetProduct={isClosetProduct}
          onClose={handleClose}
          onUpdate={handleUpdate}
        />
      )}
    </AdminSubpage>
  );
};

export default ProductEditPage;
